export default "__VITE_ASSET__9ede2f7a__"